/** Designer Plants custom storefront behaviours — CRO/performance revision Aug 2026. */
(function(){
  'use strict';

  document.querySelectorAll('.collaps').forEach(function(button){
    button.addEventListener('click',function(){
      this.classList.toggle('active');
      var content=this.nextElementSibling;
      if(!content)return;
      content.style.maxHeight=content.style.maxHeight?null:(content.scrollHeight+'px');
    });
  });

  document.querySelectorAll('video').forEach(function(video){video.setAttribute('controlsList','nodownload');});

  document.querySelectorAll('.liquid.bg-white-liquid').forEach(function(div){
    var child=div.querySelector('.image-with-text');
    if((child&&child.innerHTML.trim()==='')||div.innerHTML.trim()==='')div.style.display='none';
  });

  if(window.location.href.indexOf('over-40-green-wall-to-choose-from')!==-1){
    var galleryButton=document.querySelector('.gallery_button');
    if(galleryButton)galleryButton.setAttribute('target','_blank');
  }

  function isMobileDevice(){return typeof window.orientation!=='undefined'||navigator.userAgent.indexOf('IEMobile')!==-1;}
  if(isMobileDevice()){
    var list=document.querySelector('.footer__linklist');
    if(list&&!list.querySelector('[data-dp-footer-phone]')){
      var li=document.createElement('li'),a=document.createElement('a');
      a.href='tel:1800617341';a.className='footer__link-item link';a.textContent='Call Us: 1800 617 341';a.setAttribute('data-dp-footer-phone','');
      li.appendChild(a);list.appendChild(li);
    }
  }
})();

/* Zero-price display: server-rendered on product cards, PDP and mini-cart.
   This lightweight fallback only reacts to known storefront events/variant changes.
   No polling and no whole-document MutationObserver. */
(function(){
  'use strict';
  var ZERO=/^(?:A?\$|AUD\s*)?0(?:[.,]00)?(?:\s*AUD)?$/i;
  var SELECTORS=['.price','.product-item__price','.price-list .price','.product-meta__price','.price--large','[data-price]','.mini-cart__upsell-price'].join(',');

  function relabel(scope){
    var root=scope&&scope.querySelectorAll?scope:document,nodes=[];
    try{
      if(root.nodeType===1&&root.matches&&root.matches(SELECTORS))nodes.push(root);
      nodes=nodes.concat(Array.prototype.slice.call(root.querySelectorAll(SELECTORS)));
    }catch(e){return;}
    nodes.forEach(function(el){
      if(el.getAttribute('data-dp-free')==='1'||(el.children&&el.children.length>0))return;
      var text=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(!text||!ZERO.test(text))return;
      el.textContent='Free';el.setAttribute('data-dp-free','1');
    });
  }

  window.dpRelabelFree=relabel;
  function afterDynamic(){window.requestAnimationFrame(function(){relabel(document);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){relabel(document);},{once:true});else relabel(document);
  document.addEventListener('shopify:section:load',function(e){relabel(e.target||document);});
  document.addEventListener('collection:reloaded',function(e){relabel(e.target||document);});
  document.addEventListener('variant:changed',afterDynamic);
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('.product-form__variants'))afterDynamic();});
  document.addEventListener('cart:refresh',function(){window.setTimeout(function(){relabel(document);},120);});
  document.addEventListener('product:added',function(){window.setTimeout(function(){relabel(document);},120);});
})();

/* Mini-cart additions: recommendations, promo field and resilient redraw handling. */
(function(){
  'use strict';
  var UPSELL_LIMIT=8,DEBOUNCE_MS=150,RESCAN_DELAYS=[150,600,1400];
  var suppress=false,scanning=false,debounceTimer=null,observer=null;

  function escapeHtml(value){return String(value===null||value===undefined?'':value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\"/g,'&quot;').replace(/'/g,'&#39;');}
  function closestFrom(node,selector){if(!node)return null;var el=node.nodeType===1?node:node.parentElement;return el&&el.closest?el.closest(selector):null;}
  function toCents(value){if(value===null||value===undefined||value==='')return null;if(typeof value==='number')return Math.round(value);var text=String(value).trim();if(!text)return null;if(text.indexOf('.')!==-1)return Math.round(parseFloat(text)*100);var parsed=parseInt(text,10);return isNaN(parsed)?null:parsed;}
  function money(cents){if(cents===null||isNaN(cents))return '';if(Number(cents)===0)return 'Free';var amount=cents/100;try{return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(amount);}catch(e){return '$'+amount.toFixed(2);}}
  function sizedImage(src,width){if(!src)return '';var url=src.indexOf('//')===0?'https:'+src:src;return url+(url.indexOf('?')===-1?'?':'&')+'width='+width;}
  function write(fn){suppress=true;try{fn();}finally{setTimeout(function(){suppress=false;},0);}}

  function fetchRecommendations(productId,intent){
    var url='/recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit='+UPSELL_LIMIT+'&intent='+encodeURIComponent(intent);
    return fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(data){return data&&data.products||[];}).catch(function(){return [];});
  }

  function buildCard(product,excluded){
    if(!product||product.available===false||excluded.indexOf(String(product.id))!==-1)return '';
    var variants=product.variants||[],variant=null;
    for(var i=0;i<variants.length;i++){if(variants[i]&&variants[i].available!==false){variant=variants[i];break;}}
    if(!variant||variant.id===undefined||variant.id===null)return '';
    var priceCents=toCents(variant.price!==undefined?variant.price:product.price);
    var compareCents=toCents(variant.compare_at_price!==undefined?variant.compare_at_price:product.compare_at_price);
    var showCompare=compareCents!==null&&priceCents!==null&&compareCents>priceCents;
    var image=sizedImage(product.featured_image||(product.images&&product.images[0]),88),title=escapeHtml(product.title),url=escapeHtml(product.url||'#');
    return '<div class="mini-cart__upsell-card" role="listitem">'
      +'<a class="mini-cart__upsell-link" href="'+url+'" data-no-instant tabindex="-1" aria-hidden="true">'
      +(image?'<img class="mini-cart__upsell-thumb" src="'+escapeHtml(image)+'" alt="" loading="lazy" width="44" height="44">':'<span class="mini-cart__upsell-thumb--empty" aria-hidden="true"></span>')+'</a>'
      +'<div class="mini-cart__upsell-body"><a class="mini-cart__upsell-title" href="'+url+'" data-no-instant>'+title+'</a><div class="mini-cart__upsell-price-list"><span class="mini-cart__upsell-price">'+escapeHtml(money(priceCents))+'</span>'
      +(showCompare?'<span class="mini-cart__upsell-compare">'+escapeHtml(money(compareCents))+'</span>':'')+'</div></div>'
      +'<button type="button" class="mini-cart__upsell-add" data-mc-upsell-add data-mc-variant-id="'+escapeHtml(variant.id)+'">Add to cart</button></div>';
  }

  function updateArrows(block){
    var track=block.querySelector('[data-mc-upsell-track]'),nav=block.querySelector('[data-mc-upsell-nav]');if(!track||!nav)return;
    var overflowing=track.scrollWidth>track.clientWidth+2;nav.hidden=!overflowing;if(!overflowing)return;
    var prev=block.querySelector('[data-mc-upsell-prev]'),next=block.querySelector('[data-mc-upsell-next]'),max=track.scrollWidth-track.clientWidth;
    if(prev)prev.disabled=track.scrollLeft<=2;if(next)next.disabled=track.scrollLeft>=max-2;
  }

  function bindTrackScroll(block){
    var track=block.querySelector('[data-mc-upsell-track]');if(!track||track.getAttribute('data-mc-scroll-bound')==='1')return;
    track.setAttribute('data-mc-scroll-bound','1');track.addEventListener('scroll',function(){write(function(){updateArrows(block);});},{passive:true});
  }

  function render(block,products){
    var track=block.querySelector('[data-mc-upsell-track]');if(!track)return;
    var excluded=(block.getAttribute('data-mc-upsell-exclude')||'').split(',').map(function(v){return v.trim();}).filter(Boolean),html='';
    for(var i=0;i<products.length;i++)html+=buildCard(products[i],excluded);
    write(function(){if(!html){track.innerHTML='';block.hidden=true;return;}track.innerHTML=html;block.hidden=false;bindTrackScroll(block);updateArrows(block);});
    if(window.dpRelabelFree)window.dpRelabelFree(block);
  }

  function populate(block){
    var productId=block.getAttribute('data-mc-upsell-product');if(!productId){write(function(){block.hidden=true;});return;}
    var key=productId+'|'+(block.getAttribute('data-mc-upsell-exclude')||''),state=block.getAttribute('data-mc-upsell-state');
    if(state==='loading'||(state==='done'&&block.getAttribute('data-mc-upsell-key')===key))return;
    write(function(){block.setAttribute('data-mc-upsell-state','loading');});
    fetchRecommendations(productId,'complementary').then(function(products){return products&&products.length?products:fetchRecommendations(productId,'related');}).then(function(products){render(block,products||[]);}).catch(function(){write(function(){block.hidden=true;});}).then(function(){write(function(){block.setAttribute('data-mc-upsell-key',key);block.setAttribute('data-mc-upsell-state','done');});});
  }

  function scan(){if(scanning)return;scanning=true;try{Array.prototype.forEach.call(document.querySelectorAll('[data-mc-upsell]'),populate);}finally{scanning=false;}}
  function scheduleScan(){if(suppress)return;clearTimeout(debounceTimer);debounceTimer=setTimeout(scan,DEBOUNCE_MS);}
  function scheduleRescans(){for(var i=0;i<RESCAN_DELAYS.length;i++)setTimeout(scan,RESCAN_DELAYS[i]);}
  function observeDrawer(){
    if(!window.MutationObserver)return;var form=document.getElementById('mini-cart'),target=(form&&form.parentNode)||document.body;if(!target)return;
    if(observer&&observer.mcTarget===target)return;if(observer)observer.disconnect();
    observer=new MutationObserver(function(mutations){if(suppress)return;for(var i=0;i<mutations.length;i++){if(closestFrom(mutations[i].target,'[data-mc-upsell]'))continue;scheduleScan();if(window.dpRelabelFree)window.dpRelabelFree(target);return;}});
    observer.observe(target,{childList:true,subtree:true});observer.mcTarget=target;
  }

  function scrollTrack(button,direction){var block=closestFrom(button,'[data-mc-upsell]'),track=block&&block.querySelector('[data-mc-upsell-track]');if(!track)return;var card=track.querySelector('.mini-cart__upsell-card'),step=card?card.offsetWidth+8:Math.round(track.clientWidth*.8);if(typeof track.scrollBy==='function')track.scrollBy({left:step*direction,behavior:'smooth'});else track.scrollLeft+=step*direction;}

  function addToCart(button){
    if(button.disabled)return;var variantId=button.getAttribute('data-mc-variant-id');if(!variantId)return;var parsed=parseInt(variantId,10),original=button.textContent;
    document.dispatchEvent(new CustomEvent('dp:cart-add-start'));
    write(function(){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Adding';});
    function restore(label){write(function(){button.textContent=label;button.disabled=false;button.removeAttribute('aria-busy');});}
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:isNaN(parsed)?variantId:parsed,quantity:1}]})}).then(function(r){if(!r.ok)throw new Error('Add to cart failed');return r.json();}).then(function(){write(function(){button.textContent='Added to cart ✓';button.removeAttribute('aria-busy');});document.dispatchEvent(new CustomEvent('dp:cart-added'));document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));setTimeout(function(){restore(original);},1200);scheduleRescans();}).catch(function(){restore('Could not add');setTimeout(function(){restore(original);},2500);});
  }

  function togglePromo(button){var id=button.getAttribute('aria-controls'),wrapper=(id&&document.getElementById(id))||document.querySelector('[data-mc-promo]');if(!wrapper)return;var expanded=button.getAttribute('aria-expanded')==='true';write(function(){button.setAttribute('aria-expanded',expanded?'false':'true');if(expanded)wrapper.setAttribute('hidden','hidden');else wrapper.removeAttribute('hidden');});if(!expanded){var input=wrapper.querySelector('[data-mc-promo-input]');if(input)input.focus();}}
  function applyPromo(scope){
    var wrapper=closestFrom(scope,'[data-mc-promo]'),input=wrapper&&wrapper.querySelector('[data-mc-promo-input]'),button=wrapper&&wrapper.querySelector('[data-mc-promo-apply]');
    if(!input)return;
    var code=(input.value||'').trim();
    if(!code){input.focus();return;}
    var original=button?button.textContent:'Apply',root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    if(button){write(function(){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Applying';});}
    fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})})
      .then(function(r){if(!r.ok)throw new Error('Discount update failed');return r.json();})
      .then(function(){document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));scheduleRescans();if(button)setTimeout(function(){write(function(){button.disabled=false;button.removeAttribute('aria-busy');button.textContent=original;});},800);})
      .catch(function(){if(button){write(function(){button.disabled=false;button.removeAttribute('aria-busy');button.textContent='Try again';});setTimeout(function(){write(function(){button.textContent=original;});},2200);}});
  }

  document.addEventListener('click',function(event){
    var target=event.target,add=closestFrom(target,'[data-mc-upsell-add]');if(add){event.preventDefault();addToCart(add);return;}
    var prev=closestFrom(target,'[data-mc-upsell-prev]');if(prev){event.preventDefault();scrollTrack(prev,-1);return;}
    var next=closestFrom(target,'[data-mc-upsell-next]');if(next){event.preventDefault();scrollTrack(next,1);return;}
    var toggle=closestFrom(target,'[data-mc-promo-toggle]');if(toggle){event.preventDefault();togglePromo(toggle);return;}
    var apply=closestFrom(target,'[data-mc-promo-apply]');if(apply){event.preventDefault();applyPromo(apply);}
  });
  document.addEventListener('keydown',function(event){if(event.key!=='Enter'&&event.keyCode!==13)return;var input=closestFrom(event.target,'[data-mc-promo-input]');if(!input)return;event.preventDefault();event.stopPropagation();applyPromo(input);},true);

  function boot(){observeDrawer();scan();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('cart:refresh',function(){observeDrawer();scheduleRescans();});
  document.addEventListener('product:added',function(){observeDrawer();scheduleRescans();});
  document.addEventListener('shopify:section:load',function(){observeDrawer();scheduleScan();});
})();

/* Desktop mini-cart close control and backdrop. */
(function(){
  'use strict';
  if(window.dpMiniCartDrawerBound)return;window.dpMiniCartDrawerBound=true;
  var SCRIM_CLASS='mini-cart-scrim',TOGGLE_SELECTOR='[data-action="toggle-mini-cart"]',THEME_CLOSE_GRACE_MS=80;
  function closestFrom(node,selector){if(!node)return null;var el=node.nodeType===1?node:node.parentElement;return el&&el.closest?el.closest(selector):null;}
  function isOpen(){var form=document.getElementById('mini-cart');return !!form&&form.getAttribute('aria-hidden')==='false';}
  function closeViaTheme(){if(!isOpen())return;var toggle=document.querySelector(TOGGLE_SELECTOR);if(!toggle)return;var block=function(e){e.preventDefault();};toggle.addEventListener('click',block);try{toggle.click();}finally{toggle.removeEventListener('click',block);}}
  function closeAfterTheme(){if(!isOpen())return;setTimeout(function(){if(isOpen())closeViaTheme();},THEME_CLOSE_GRACE_MS);}
  function ensureScrim(){if(!document.body||document.querySelector('.'+SCRIM_CLASS))return;var scrim=document.createElement('div');scrim.className=SCRIM_CLASS;scrim.setAttribute('data-mc-scrim','');scrim.setAttribute('aria-hidden','true');document.body.appendChild(scrim);}
  document.addEventListener('click',function(event){if(closestFrom(event.target,'[data-mc-drawer-close]')){event.preventDefault();closeViaTheme();return;}if(closestFrom(event.target,'[data-mc-scrim]'))closeAfterTheme();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ensureScrim,{once:true});else ensureScrim();
  document.addEventListener('shopify:section:load',ensureScrim);document.addEventListener('cart:refresh',ensureScrim);
})();


/* ===== DP AU mobile header v2 A+: hide the search bar on scroll down, show on scroll up / page top / focus; magnifier icon in the top row while collapsed (phones only) ===== */
(function () {
  var mq = window.matchMedia('(max-width: 640px)');
  var root = document.documentElement;
  var last = 0, ticking = false, collapsed = false;
  var SVG = '<svg focusable="false" class="icon icon--search" viewBox="0 0 21 21" role="presentation"><g stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd"><path d="M19 19l-5-5" stroke-linecap="square"></path><circle cx="8.5" cy="8.5" r="7.5"></circle></g></svg>';

  function wrapper() { return document.querySelector('.shopify-section__header .header__search-bar-wrapper'); }
  function setCollapsed(v) {
    if (v === collapsed) { return; }
    collapsed = v;
    root.classList.toggle('dp-search-collapsed', v);
    var b = document.querySelector('.dp-hdr-search__btn');
    if (b) { b.setAttribute('aria-hidden', v ? 'false' : 'true'); b.tabIndex = v ? 0 : -1; }
  }
  function prep() {
    var w = wrapper();
    if (!w) { return; }
    if (mq.matches) {
      var input = w.querySelector('.search-bar__input');
      if (input && input.getAttribute('placeholder') !== 'Search plants, green walls\u2026') {
        input.setAttribute('placeholder', 'Search plants, green walls\u2026');
        input.setAttribute('aria-label', 'Search plants, green walls');
      }
    }
    addButton();
  }
  function addButton() {
    if (document.querySelector('.dp-hdr-search')) { return; }
    var list = document.querySelector('.shopify-section__header .header__action-list');
    if (!list) { return; }
    var item = document.createElement('div');
    item.className = 'header__action-item dp-hdr-search';
    item.innerHTML = '<button type="button" class="dp-hdr-search__btn" aria-label="Search" aria-hidden="true" tabindex="-1">' + SVG + '</button>';
    list.insertBefore(item, list.firstChild);
    item.querySelector('button').addEventListener('click', openSearch);
  }
  // Tap on the magnifier: expand the header and focus the search input inside the same tap (keeps the phone keyboard opening).
  function openSearch(e) {
    if (e) { e.preventDefault(); }
    var w = wrapper();
    var input = w && w.querySelector('.search-bar__input');
    if (!input) { return; }
    root.classList.add('dp-search-opening');   // no transition: bar is visible/focusable immediately
    setCollapsed(false);
    void w.offsetHeight;                      // flush styles so visibility is already 'visible'
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    last = Math.max(0, window.pageYOffset || 0);
    window.setTimeout(function () { root.classList.remove('dp-search-opening'); }, 350);
  }
  function busy() {
    var w = wrapper();
    var inp = w && w.querySelector('.search-bar__input');
    if (inp && document.activeElement === inp) { return true; }           // typing / field focused
    if (inp && inp.value) { return true; }                                // field has text
    if (w && w.classList.contains('is-fixed')) { return true; }           // full-screen search open
    return !!document.querySelector('.header__mobile-nav-toggle[aria-expanded="true"]');
  }
  function update() {
    ticking = false;
    if (!mq.matches) { setCollapsed(false); return; }
    var y = Math.max(0, window.pageYOffset || 0);
    if (busy() || y <= 60) { setCollapsed(false); last = y; return; }
    var d = y - last;
    if (d > 8) { setCollapsed(true); last = y; }
    else if (d < -4) { setCollapsed(false); last = y; }
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { prep(); onScroll(); }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var w = wrapper();
    if (w && w.contains(e.target)) { setCollapsed(false); last = Math.max(0, window.pageYOffset || 0); }
  });
  document.addEventListener('focusout', function () { last = Math.max(0, window.pageYOffset || 0); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', prep); } else { prep(); }
  window.addEventListener('load', prep);
  last = window.pageYOffset || 0;
})();
/* ===== /DP AU mobile header v2 A+ ===== */

/* ===== DP AU chat widget: right side, hide on overlays, clearance for sticky Add to Cart (GHL) ===== */
(function () {
  'use strict';
  var root = document.documentElement;
  var mqHide = window.matchMedia('(max-width: 999px)');
  var mqMob = window.matchMedia('(max-width: 767px)');
  var AVOID = '[data-dp-main-atc],[class*="add-btn"],.product-item__action-button';
  var BASE = 20;               /* GHL's own default bottom offset */
  var pending = false, host = null, sr = null;
  function isOpen(sel) { var e = document.querySelector(sel); return !!e && e.getAttribute('aria-hidden') === 'false'; }
  function isProduct() { return !!document.body && document.body.classList.contains('template-product'); }
  function visRect(e) {
    var r = e.getBoundingClientRect();
    if (r.width < 2 || r.height < 2 || r.bottom <= 0 || r.top >= window.innerHeight) { return null; }
    var c = window.getComputedStyle(e);
    if (c.display === 'none' || c.visibility === 'hidden' || c.opacity === '0') { return null; }
    return r;
  }
  function grab() {
    if (!host) { host = document.querySelector('chat-widget'); }
    if (host && !sr && host.shadowRoot) {
      sr = host.shadowRoot;
      try { new MutationObserver(schedule).observe(sr, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] }); } catch (e) {}
    }
    if (sr && !sr.getElementById('dp-ghl-right')) {
      /* Mirror to the right ONLY while GHL itself positions the widget with an inline "left:" (i.e. the widget is set to Left in GHL).
         If it is switched to Right inside GHL these selectors stop matching and GHL's own placement is used untouched. */
      var s = document.createElement('style'); s.id = 'dp-ghl-right';
      s.textContent = '#lc_text-widget[style*="left"],#lc_text-widget--btn[style*="left"]{left:auto !important;right:20px !important}';
      sr.appendChild(s);
    }
  }
  function stickyLift() {
    if (!isProduct()) { return 0; }
    var bar = document.querySelector('[data-dp-sticky]');
    if (bar && bar.classList.contains('is-visible')) {
      var br = bar.getBoundingClientRect();
      if (br.height > 0 && br.top < window.innerHeight) { return Math.round(window.innerHeight - br.top + 16); }
    }
    return 0;
  }
  function update() {
    pending = false;
    /* 1. hide while overlays are open */
    var hide = isOpen('#mini-cart') ||
      (mqHide.matches && (isOpen('#mobile-menu') || isOpen('#mobile-collection-filters') || isOpen('.search-bar__results')));
    root.classList.toggle('dp-chat-hide', hide);
    grab();
    if (!sr) { return; }
    var btn = sr.getElementById('lc_text-widget--btn');
    var box = sr.getElementById('lc_text-widget');
    /* 2. bottom offset: GHL default, lifted above the sticky Add to Cart bar only while it shows.
          The older theme script (layout/theme.liquid) adds a fixed +82px on phones from data-dp-chat-base-bottom; we feed it (want - 82) so both agree. */
    var lift = stickyLift();
    var want = lift ? Math.max(BASE, lift) : BASE;
    [btn, box].forEach(function (el) {
      if (!el || !el.style || !el.style.bottom) { return; }       /* GHL not positioning inline (e.g. open full-width panel on phones): leave it */
      if (mqMob.matches) { el.setAttribute('data-dp-chat-base-bottom', String(want - 82)); }
      if (el.style.getPropertyValue('bottom') !== want + 'px' || el.style.getPropertyPriority('bottom') !== 'important') {
        el.style.setProperty('bottom', want + 'px', 'important');
      }
    });
    /* 3. fade out while the bubble sits on an Add to Cart button (product pages); never while a chat is open */
    var avoid = false;
    if (isProduct() && btn && !(box && box.classList.contains('lc_text-widget--active'))) {
      var b = btn.getBoundingClientRect();
      if (b.width > 2) {
        var els = document.querySelectorAll(AVOID), m = 10;
        for (var i = 0; i < els.length && !avoid; i++) {
          var r = visRect(els[i]);
          if (r && r.left < b.right + m && r.right > b.left - m && r.top < b.bottom + m && r.bottom > b.top - m) { avoid = true; }
        }
      }
    }
    root.classList.toggle('dp-chat-avoid', avoid);
  }
  function schedule() { if (!pending) { pending = true; window.requestAnimationFrame(update); } }
  function start() {
    if (!document.body) { return; }
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('transitionend', schedule, true);
    (mqHide.addEventListener ? mqHide.addEventListener('change', schedule) : mqHide.addListener(schedule));
    window.setInterval(schedule, 700);     /* GHL loads late (on first interaction/idle) */
    schedule();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
/* ===== /DP AU chat widget ===== */

/* ===== DP AU mini-cart "Complete the install" no-jump (25 Oct 2026) =====
   Remembers the last rendered recommendation cards and puts them straight back (before the browser paints) whenever the
   theme re-renders the drawer, so the block never goes empty -> full while the real recommendations are re-fetched. */
(function () {
  var cache = null;
  function cards(block) { var t = block && block.querySelector('[data-mc-upsell-track]'); return t; }
  function restore(block) {
    var t = cards(block);
    if (!cache || !t || t.children.length || block.getAttribute('data-mc-upsell-state')) return;
    t.innerHTML = cache;
    block.hidden = false;
  }
  function sync() {
    var blocks = document.querySelectorAll('[data-mc-upsell]');
    for (var i = 0; i < blocks.length; i++) {
      var t = cards(blocks[i]);
      if (!t) continue;
      if (t.children.length) { cache = t.innerHTML; }
      else { restore(blocks[i]); }
    }
  }
  function start() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tg = muts[i].target;
        if (tg && tg.nodeType === 1 && (tg.id === 'mini-cart' || tg.closest && tg.closest('[data-mc-upsell-track]') || tg.querySelector && tg.querySelector('[data-mc-upsell]'))) { sync(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* ===== /DP AU mini-cart no-jump ===== */

/* Success feedback only: never starts or repeats a cart request. */
(function(){
  'use strict';
  if(window.dpCartSuccessFeedbackBound)return;
  window.dpCartSuccessFeedbackBound=true;
  var expires=0,timer=0,eligible=false,drawer=null,observer=null,wasOpen=false,live=null;
  function isOpen(el){return !!el&&el.getAttribute('aria-hidden')==='false';}
  function liveRegion(){
    if(live&&document.body.contains(live))return live;
    live=document.createElement('span');
    live.className='visually-hidden';
    live.setAttribute('role','status');
    live.setAttribute('aria-live','polite');
    live.setAttribute('aria-atomic','true');
    document.body.appendChild(live);
    return live;
  }
  function paint(){
    var label=document.querySelector('#mini-cart [data-cart-add-feedback]');
    var message=eligible&&expires>Date.now()&&isOpen(drawer)?'Added to cart ✓':'';
    if(label&&label.textContent!==message)label.textContent=message;
  }
  function clear(){
    expires=0;eligible=false;window.clearTimeout(timer);
    if(live)live.textContent='';
    paint();
  }
  function bind(){
    if(document.body)liveRegion();
    var current=document.getElementById('mini-cart');
    if(current!==drawer){
      if(observer)observer.disconnect();
      drawer=current;wasOpen=isOpen(drawer);
      if(drawer&&window.MutationObserver){
        observer=new MutationObserver(function(){
          var open=isOpen(drawer);
          if(wasOpen&&!open)clear();
          wasOpen=open;paint();
        });
        observer.observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
      }
    }
    paint();
  }
  function success(event){
    bind();
    expires=Date.now()+4000;
    eligible=isOpen(drawer)||event.type==='product:added';
    var status=liveRegion();status.textContent='';
    window.requestAnimationFrame(function(){if(expires>Date.now())status.textContent='Added to cart.';});
    paint();window.clearTimeout(timer);timer=window.setTimeout(clear,4000);
  }
  document.addEventListener('dp:cart-add-start',clear);
  document.addEventListener('click',function(event){
    var target=event.target&&event.target.closest?event.target.closest('[data-action="add-to-cart"]'):null;
    if(target&&!target.disabled)clear();
  },true);
  document.addEventListener('product:added',success);
  document.addEventListener('dp:cart-added',success);
  document.addEventListener('cart:rerendered',bind,true);
  document.addEventListener('shopify:section:load',bind);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();
})();
